export default {"src":"/_next/static/media/webcomm.3fc6c83b.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};